
const CORRECT_BASE_URL = 'https://api.at-work.biz/api';
const CORRECT_WS_URL = 'wss://api.at-work.biz/api';

// Simplified environment configuration

const rawBaseUrl = import.meta.env.VITE_DATA_API || CORRECT_BASE_URL;
const rawWsUrl = import.meta.env.VITE_WS_URL || CORRECT_WS_URL;

// Sanitize to avoid old/staging URLs in production
const sanitizedBaseUrl =
  (rawBaseUrl.includes('ai.lnk2.im') || rawBaseUrl.includes('9001')) ? CORRECT_BASE_URL : rawBaseUrl;
const sanitizedWsUrl =
  (rawWsUrl.includes('ai.lnk2.im') || rawWsUrl.includes('9001') || rawWsUrl.startsWith('ws://'))
    ? CORRECT_WS_URL
    : rawWsUrl;

// Only log warnings if not in NONE log level mode
const logLevel = (import.meta.env.VITE_LOG_LEVEL || '').toUpperCase();
const shouldLog = logLevel !== 'NONE' && !import.meta.env.PROD;

if (sanitizedBaseUrl !== rawBaseUrl && shouldLog) {
  console.warn('⚠️ Overriding invalid VITE_DATA_API with production URL', { from: rawBaseUrl, to: sanitizedBaseUrl });
}
if (sanitizedWsUrl !== rawWsUrl && shouldLog) {
  console.warn('⚠️ Overriding invalid VITE_WS_URL with production URL', { from: rawWsUrl, to: sanitizedWsUrl });
}

export const apiConfig = {
  baseUrl: sanitizedBaseUrl,
  wsUrl: sanitizedWsUrl,
  liveWsUrl: import.meta.env.VITE_LIVE_WS_URL || 'wss://api.at-work.biz/api',
  publicHealthUrl: import.meta.env.VITE_PUBLIC_HEALTH_URL || 'https://api.at-work.biz/health',
  // Enable WebSocket research by default unless explicitly set to "false"
  enableWebSocketResearch: import.meta.env.REACT_APP_ENABLE_WEBSOCKET_RESEARCH !== "false",
  scrapingServiceUrl: `${CORRECT_BASE_URL}/scraping`,
  aiServiceUrl: `${CORRECT_BASE_URL}/ai`
};

export const emailConfig = {
  apiEndpoint: import.meta.env.VITE_EMAIL_API_ENDPOINT || 'https://send.api.mailtrap.io/api/send',
  apiKey: import.meta.env.VITE_EMAIL_API_KEY || '',
  email: import.meta.env.VITE_EMAIL_FROM_ADDRESS || 'noreply@at-work.biz',
  fullName: import.meta.env.VITE_EMAIL_FROM_NAME || 'At Work Team',
  imapHost: import.meta.env.VITE_IMAP_HOST || 'imap.gmail.com',
  imapPort: parseInt(import.meta.env.VITE_IMAP_PORT || '993'),
  imapSecure: import.meta.env.VITE_IMAP_SECURE !== 'false',
  imapEmail: import.meta.env.VITE_IMAP_EMAIL || 'sarah@livingcolors.studio',
  imapPassword: import.meta.env.VITE_IMAP_PASSWORD || '',
  imapServer: import.meta.env.VITE_IMAP_HOST || 'imap.gmail.com',
  imapUser: import.meta.env.VITE_IMAP_USERNAME || '',
  imapPass: import.meta.env.VITE_IMAP_PASS || '',
  smtpHost: import.meta.env.VITE_SMTP_HOST || 'smtp.gmail.com',
  smtpPort: parseInt(import.meta.env.VITE_SMTP_PORT || '587'),
  smtpSecure: import.meta.env.VITE_SMTP_SECURE === 'true',
  smtpServer: import.meta.env.VITE_SMTP_HOST || 'smtp.gmail.com',
  smtpUsername: import.meta.env.VITE_SMTP_USERNAME || '',
  smtpPassword: import.meta.env.VITE_SMTP_PASSWORD || '',
  smtpUser: import.meta.env.VITE_SMTP_USER || '',
  checkFrequency: import.meta.env.VITE_EMAIL_CHECK_FREQUENCY || '15'
};

export const databaseConfig = {
  host: import.meta.env.VITE_DB_HOST || 'localhost',
  port: parseInt(import.meta.env.VITE_DB_PORT || '3306'),
  database: import.meta.env.VITE_DB_NAME || 'at_work_db',
  user: import.meta.env.VITE_DB_USER || 'root',
  username: import.meta.env.VITE_DB_USER || 'root',
  password: import.meta.env.VITE_DB_PASSWORD || '',
  ssl: import.meta.env.VITE_DB_SSL === 'true',
  apiBaseUrl: sanitizedBaseUrl
};

export const googleConfig = {
  apiKey: import.meta.env.VITE_GOOGLE_API || '',
  searchEngineId: import.meta.env.VITE_GOOGLE_SEARCH_ENGINE_ID || '',
  mapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '',
  sheetsScope: 'https://www.googleapis.com/auth/spreadsheets.readonly'
};

export const proxycurlConfig = {
  apiKey: import.meta.env.VITE_PROXYCURL_API || import.meta.env.PROXYCURL_API || '',
  baseUrl: 'https://nubela.co/proxycurl/api'
};

export const twilioConfig = {
  accountSid: import.meta.env.VITE_TWILIO_ACCOUNT_SID || '',
  authToken: import.meta.env.VITE_TWILIO_AUTH_TOKEN || '',
  phoneNumber: import.meta.env.VITE_TWILIO_PHONE_NUMBER || '',
  fromNumber: import.meta.env.VITE_TWILIO_PHONE_NUMBER || '',
  apiKey: import.meta.env.VITE_TWILIO_API_KEY || '',
  apiSecret: import.meta.env.VITE_TWILIO_API_SECRET || ''
};

export const aiConfig = {
  openaiApiKey: import.meta.env.VITE_OPENAI_API_KEY || '',
  elevenLabsApiKey: import.meta.env.VITE_ELEVEN_LABS_API_KEY || '',
  elevenLabsKey: import.meta.env.VITE_ELEVEN_LABS_API_KEY || '',
  elevenLabsVoiceId: import.meta.env.VITE_ELEVEN_LABS_VOICE_ID || '',
  serviceUrl: import.meta.env.VITE_AI_SERVICE_URL || 'https://api.at-work.biz/api/ai'
};

// Log Level Configuration
// Available options:
// VITE_LOG_LEVEL=DETAILED  # Shows all logs
// VITE_LOG_LEVEL=MINIMAL   # Only warnings and errors  
// VITE_LOG_LEVEL=NONE      # No logs
export const logConfig = {
  level: (import.meta.env.VITE_LOG_LEVEL || '').toUpperCase() as 'NONE' | 'MINIMAL' | 'DETAILED',
  isProduction: import.meta.env.PROD,
  defaultLevel: import.meta.env.PROD ? 'MINIMAL' : 'DETAILED'
};
